module.exports = __webpack_public_path__ + "static/media/logo-guests.9731f2d5.png";